var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "switch ml-1" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.toggleValue,
          expression: "toggleValue"
        }
      ],
      attrs: { type: "checkbox", id: "togBtn" },
      domProps: {
        checked: Array.isArray(_vm.toggleValue)
          ? _vm._i(_vm.toggleValue, null) > -1
          : _vm.toggleValue
      },
      on: {
        change: [
          function($event) {
            var $$a = _vm.toggleValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.toggleValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.toggleValue = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.toggleValue = $$c
            }
          },
          _vm.valueChanged
        ]
      }
    }),
    _c("div", { staticClass: "slider round", style: _vm.leftStyle }, [
      _c("span", { staticClass: "on" }, [_vm._v("°C")]),
      _c("span", { staticClass: "off" }, [_vm._v("°F")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }